export default __webpack_public_path__ + "static/media/mike.eef506e1.jpg";